import React from 'react';
 
// Creating the context object and passing the default values.
const AppContext = React.createContext({ permissions: null });
 
export default AppContext;